var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ve-histogram',{attrs:{"settings":_vm.barSettings,"height":"260px","width":"300px","extend":_vm.barExtend,"data":_vm.datas,"yAxis":_vm.yAxis}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }